export default {

  doRegionAverage (data, query, numeratorField, denominatorField, regionId, useMulti) {
    var years = []

    var hist = []
    var hist1a = []
    var hist1b = []
    var hist2 = []

    var hden = []
    var hden1a = []
    var hden1b = []
    var hden2 = []

    if (useMulti) {
      numeratorField += (query.organMode === 'multi' ? '_multi' : '_single')
      denominatorField += (query.organMode === 'multi' ? '_multi' : '_single')
    }

    data.forEach(function (item) {
      let isRelevant =
        (query.regionMode === 'unos' && regionId === parseInt(item['unos_id'])) ||
        (query.regionMode === 'opo' && regionId === parseInt(item['opo_id'])) ||
        (query.regionMode === 'state' && regionId === item['state'])

      if (isRelevant) {
        let yIndex = years.indexOf(item.year)

        if (yIndex === -1) {
          yIndex = years.length
          years.push(item.year)
          hist[yIndex] = 0
          hden[yIndex] = 0
          hist1a[yIndex] = 0
          hden1a[yIndex] = 0
          hist1b[yIndex] = 0
          hden1b[yIndex] = 0
          hist2[yIndex] = 0
          hden2[yIndex] = 0
        }

        hist[yIndex] += item[numeratorField]
        hden[yIndex] += item[denominatorField]
        hist1a[yIndex] += item[numeratorField + '_1a']
        hden1a[yIndex] += item[denominatorField + '_1a']
        hist1b[yIndex] += item[numeratorField + '_1b']
        hden1b[yIndex] += item[denominatorField + '_1b']
        hist2[yIndex] += item[numeratorField + '_2']
        hden2[yIndex] += item[denominatorField + '_2']
      }
    })

    // Finalize averages
    let hCnt = hist.length
    for (let i = 0; i < hCnt; i++) {
      hist[i] /= hden[i]
      hist1a[i] /= hden1a[i]
      hist1b[i] /= hden1b[i]
      hist2[i] /= hden2[i]
    }

    return { years, hist, hist1a, hist1b, hist2 }
  },

  r_stat_1 (data, query, regionId) {
    return this.doRegionAverage(data, query, 'recipients', 'candidates', regionId, true)
  },

  r_stat_2 (data, query, regionId) {
    return this.doRegionAverage(data, query, 'offers_declined', 'offers', regionId, false)
  },

  r_stat_4 (data, query, regionId) {
    return this.doRegionAverage(data, query, 'offers_accepted_lq', 'offers_accepted', regionId, false)
  },

  r_stat_5 (data, query, regionId) {
    return this.doRegionAverage(data, query, 'offers_accepted_mq', 'offers_accepted', regionId, false)
  },

  r_stat_6 (data, query, regionId) {
    return this.doRegionAverage(data, query, 'offers_accepted_hq', 'offers_accepted', regionId, false)
  },

  r_stat_7 (data, query, regionId) {
    return this.doRegionAverage(data, query, 'sumischemic', 'recipients', regionId, true)
  },

  r_stat_8 (data, query, regionId) {
    return this.doRegionAverage(data, query, 'sumwaiting', 'recipients', regionId, true)
  },

  r_stat_9 (data, query, years, regionId) {
    return this.doRegionAverage(data, query, 'dead' + years + 'yr', 'recipients', regionId, true)
  },

  r_stat_9_1 (data, query, regionId) {
    return this.r_stat_9(data, query, '1', regionId)
  },

  r_stat_9_3 (data, query, regionId) {
    return this.r_stat_9(data, query, '3', regionId)
  },

  r_stat_9_5 (data, query, regionId) {
    return this.r_stat_9(data, query, '5', regionId)
  },

  r_stat_10 (data, query, years, regionId) {
    return this.doRegionAverage(data, query, 'fail' + years + 'yr', 'recipients', regionId, true)
  },

  r_stat_10_1 (data, query, regionId) {
    return this.r_stat_10(data, query, '1', regionId)
  },

  r_stat_10_3 (data, query, regionId) {
    return this.r_stat_10(data, query, '3', regionId)
  },

  r_stat_10_5 (data, query, regionId) {
    return this.r_stat_10(data, query, '5', regionId)
  },

  r_stat_11 (data, query, regionId) {
    return this.doRegionAverage(data, query, 'unused_organs', 'available_organs', regionId, false)
  },

  r_stat_12 (data, query, regionId) {
    return this.doRegionAverage(data, query, 'declined_quality_organs', 'available_organs', regionId, false)
  }

}



// WEBPACK FOOTER //
// ./src/api/region.js